import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { BookOpenCheck, Users, TrendingUp } from "lucide-react";

const RestaurantPartner = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800 transition-colors duration-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-800 dark:text-white mb-4">
            Are You a Restaurant Owner?
          </h2>
          <p className="max-w-2xl mx-auto text-lg text-gray-600 dark:text-gray-300">
            Join our network of premium restaurants and discover a new revenue stream,
            while welcoming enthusiastic diners to your establishment.
          </p>

          <Button
            onClick={() => { window.location.href = '/restaurant-signup'; }}
            size="lg"
            className="bg-primary text-white hover:bg-primary/90 mt-8 px-8 py-6 text-lg h-auto"
          >
            <div className="flex items-center space-x-2">
              <span>Partner With Us</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-5 w-5"
              >
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </div>
          </Button>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-12">
          <Card className="bg-white dark:bg-gray-800 shadow-lg hover:shadow-xl transition-shadow">
            <CardHeader className="pb-2">
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-primary/10 rounded-full">
                  <BookOpenCheck className="h-8 w-8 text-primary" />
                </div>
              </div>
              <CardTitle className="text-xl font-bold text-center">Fill Empty Tables</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-center text-gray-600 dark:text-gray-300 text-base">
                Transform off-peak hours into profitable service times. SurpriseTable helps you maximize
                your capacity utilization, ensuring your restaurant remains busy throughout the day.
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="bg-white dark:bg-gray-800 shadow-lg hover:shadow-xl transition-shadow">
            <CardHeader className="pb-2">
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-primary/10 rounded-full">
                  <Users className="h-8 w-8 text-primary" />
                </div>
              </div>
              <CardTitle className="text-xl font-bold text-center">Gain New Customers</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-center text-gray-600 dark:text-gray-300 text-base">
                Attract food enthusiasts looking for new dining experiences. Our platform introduces
                your restaurant to adventurous diners who may become your regular customers.
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="bg-white dark:bg-gray-800 shadow-lg hover:shadow-xl transition-shadow">
            <CardHeader className="pb-2">
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-primary/10 rounded-full">
                  <TrendingUp className="h-8 w-8 text-primary" />
                </div>
              </div>
              <CardTitle className="text-xl font-bold text-center">Additional Revenue</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-center text-gray-600 dark:text-gray-300 text-base">
                Generate predictable additional income with minimum effort. Our system simplifies
                the booking process and helps you manage "surprise" diners efficiently.
              </CardDescription>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default RestaurantPartner;
